<template>
  <div class="loader">
    <div class="loader-content">
      <div class="spinner">
        <div class="ring ring-1"></div>
        <div class="ring ring-2"></div>
        <div class="dot"></div>
      </div>
      <p class="loader-text">Chargement...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingElement",
};
</script>

<style scoped>
.loader {
  width: 100%;
  height: 100%;
  backdrop-filter: blur(12px);
  background: rgba(249, 247, 248, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.spinner {
  position: relative;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ring {
  position: absolute;
  border-radius: 50%;
  border: 2.5px solid transparent;
}

.ring-1 {
  width: 56px;
  height: 56px;
  border-top-color: #7553FC;
  border-right-color: #7553FC;
  animation: spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.ring-2 {
  width: 38px;
  height: 38px;
  border-bottom-color: #b39dfd;
  border-left-color: #b39dfd;
  animation: spin 1.4s cubic-bezier(0.4, 0, 0.2, 1) infinite reverse;
}

.dot {
  width: 8px;
  height: 8px;
  background: #7553FC;
  border-radius: 50%;
  animation: pulse 1s ease-in-out infinite;
}

.loader-text {
  font-family: 'OpenRunde', sans-serif;
  font-size: 13px;
  color: #1A1615;
  opacity: 0.5;
  letter-spacing: 0.02em;
  margin: 0;
  animation: fade 1.4s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.6); opacity: 0.4; }
}

@keyframes fade {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 0.9; }
}
</style>
